/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {AuthorizationContextPermissionsContract} from '../../../api/ms-security/contracts/authorization-context-permissions.contract';
import {Permission} from '../../utils/permission.enum';
import {PermissionEnumMapper} from '../../utils/permission-enum.mapper';
import {KeyValuePair} from '../../utils/key-value-pair.type';

export class AuthorizationContextPermissionsMapper {

    private constructor() {
    }

    static toContextPermissions(input: AuthorizationContextPermissionsContract): KeyValuePair<string, Permission[]> {
        let output: KeyValuePair<string, Permission[]>;

        if (input != null) {
            output = [input.context, PermissionEnumMapper.fromStringArray(input.permissions)];
        }

        return output;
    }

    static toContextPermissionsMap(input: AuthorizationContextPermissionsContract[]): Map<string, Permission[]> {
        return new Map(input?.map(AuthorizationContextPermissionsMapper.toContextPermissions));
    }
}
